import type { guideProfile as guideProfileEn } from "../en/guideProfile";

// Obsah profilu v editoru průvodce: země, kde provází, rozhovor, tipy a galerie.
export const guideProfile: typeof guideProfileEn = {
  countries: {
    label: "Země, kde provází",
    help: "Jen země a místa zobrazovaná jako země. První země je domovská destinace průvodce v harmonogramu; pořadí odpovídá pořadí výběru a nově přidaná země jde na konec, takže jinou první zemi nastavíte tak, že země před ní odeberete a znovu přidáte.",
  },
  interview: {
    title: "Ptali jsme se",
    empty: "Zatím žádná otázka. Bez otázek se sekce na webu nezobrazí.",
    add: "Přidat otázku",
    itemN: "Otázka {{number}}",
    question: "Otázka",
    answer: "Odpověď",
    questionPlaceholder: "např. Co vás na provázení nejvíc baví?",
    answerPlaceholder: "Prostý text; odstavce oddělte prázdným řádkem",
  },
  tips: {
    title: "Tipy",
    favoritePlace: "Oblíbené místo nebo zážitek",
    food: "Co ochutnat",
    advice: "Rada před cestou",
    favoritePlacePlaceholder: "např. Východ slunce nad rýžovými terasami v Sa Pa",
    foodPlaceholder: "např. Bún chả z pouličního stánku v Hanoji",
    advicePlaceholder: "např. Lehkou pláštěnku si vezměte i v období sucha",
  },
  gallery: {
    title: "Galerie",
  },
};
